import { useEffect, useState } from "react";
import { getLoggedinUser } from "../../helpers/api_helper";
import { getCookie } from "../../helpers/cookie_helper";

const useProfile = () => {
  const userProfileSession = getLoggedinUser();
  // Check cookie first, then fallback to localStorage token
  const cookieToken = getCookie("authToken");
  var token = cookieToken || (userProfileSession && userProfileSession["token"]);
  
  // Fix: Initialize loading to false since getLoggedinUser is synchronous
  // Loading should only be true during async operations
  const [loading, setLoading] = useState(false);
  const [userProfile, setUserProfile] = useState(
    userProfileSession ? userProfileSession : null
  );

  useEffect(() => {
    const userProfileSession = getLoggedinUser();
    const cookieToken = getCookie("authToken");
    var token = cookieToken || (userProfileSession && userProfileSession["token"]);
    setUserProfile(userProfileSession ? userProfileSession : null);
    // Fix: Set loading to false once we've checked (whether token exists or not)
    // Loading should only be true during async operations, not when we've synchronously determined auth state
    setLoading(false);
  }, []);


  return { userProfile, loading, token };
};

export { useProfile };